import { DefaultValueConfig } from '@headless-workspace/config';
import { DataLayerClassName, mapImage, mapURLToImage } from '@headless-workspace/domain/common/client';
import { PropsWithDataLayer } from '@headless-workspace/glow-ds';
import { Image, isImageWithSrc } from '@headless-workspace/typings';
import { ObjectHelpers, StringHelpers } from '@headless-workspace/utils';
import { HomeButtonsWebmoV2DTO, HomeSlotBase, HomeSlotType, mapHomeSlotBase } from '../../../../index';

type HomeFastAccessLink = PropsWithDataLayer & {
    label: string;
    subLabel?: string;
    href: string;
    image: Image;
};

export type HomeFastAccessValue = HomeSlotBase & {
    type: HomeSlotType.FastAccess;
    links: HomeFastAccessLink[];
};

export const mapHomeFastAccess = (dto: HomeButtonsWebmoV2DTO): HomeFastAccessValue => {
    return {
        ...mapHomeSlotBase(dto),
        type: HomeSlotType.FastAccess,
        links: dto.details.buttons.map((button) => {
            const image =
                mapImage(button.image) ?? ObjectHelpers.createImageWithSrc(DefaultValueConfig.imagePlaceholder);
            const imageSrc = isImageWithSrc(image) ? image.src : image.small;
            return {
                label: button.title,
                subLabel: button.subTitle,
                href: button.link,
                image,
                dataLayer: { id: StringHelpers.getFileName(imageSrc ?? ''), className: DataLayerClassName.fastAccess },
            };
        }),
    };
};
